import { ColorKeys } from 'canoe';

const colors = ['BrandPurple', 'AquaTeal', 'Warning', 'Danger', 'BerryBlue'] as ColorKeys[];

export const getSeriesColor = (seriesIndex: number) => colors[seriesIndex % colors.length];
